export default __webpack_public_path__ + "static/media/sprittel.f87b5fca.PNG";